import { render } from "./ElectionVoteOtpView.vue?vue&type=template&id=1f3ea45d"
import script from "./ElectionVoteOtpView.vue?vue&type=script&lang=js"
export * from "./ElectionVoteOtpView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Mobile\\voting2024\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__